/**
 * Product Set Loox — member reviews + star rating above the title.
 * Scoped to Product Set PDP only. Regular PDPs unchanged.
 *
 * Rating shells (.loox-rating[data-product-set-loox-rating]) are server-rendered
 * inside Dog/Human product-set content templates. Family-member swap already
 * replaces them with the active member's markup — do not remount/clear them.
 *
 * Reviews (#looxReviews) live outside hot-swapped content and are swapped from
 * <template> on product-set:content-replaced, then Loox is asked to enhance once.
 */
(function () {
  'use strict';

  var SECTION_SEL = '[data-product-set-loox-reviews]';
  var MOUNT_SEL = '[data-product-set-loox-mount]';
  var TEMPLATE_SEL = 'template[data-product-set-loox-template]';
  var ROOT_SEL = '[data-product-set-root]';
  var BOUND = 'data-product-set-loox-bound';

  var lastReviewsMember = null;

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function getSection() {
    return document.querySelector(SECTION_SEL);
  }

  function getRoot() {
    return document.querySelector(ROOT_SEL);
  }

  function getActiveMember() {
    var root = getRoot();
    if (root && root.getAttribute('data-active-member')) {
      return root.getAttribute('data-active-member');
    }
    var section = getSection();
    return (section && section.getAttribute('data-product-set-loox-active-member')) || 'dog';
  }

  /**
   * Enhance newly inserted Loox hosts (rating shells + reviews mount).
   * Prefer init/refresh over reload so already-painted widgets are not torn down
   * when only a new empty .loox-rating needs painting after a member swap.
   */
  function callLooxEnhance() {
    try {
      if (window.LOOX) {
        if (typeof window.LOOX.init === 'function') {
          window.LOOX.init();
          return true;
        }
        if (typeof window.LOOX.refresh === 'function') {
          window.LOOX.refresh();
          return true;
        }
        if (typeof window.LOOX.reload === 'function') {
          window.LOOX.reload();
          return true;
        }
      }
      if (typeof window.loox_init === 'function') {
        window.loox_init();
        return true;
      }
      if (typeof window.looxInit === 'function') {
        window.looxInit();
        return true;
      }
    } catch (e) {
      console.warn('[ProductSet Loox] Enhance failed', e);
    }
    return false;
  }

  function ensureSingleLooxReviewsId(widget) {
    if (!widget) return;
    var all = document.querySelectorAll('#looxReviews');
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== widget) {
        all[i].removeAttribute('id');
      }
    }
    widget.id = 'looxReviews';
  }

  /**
   * Swap the reviews mount to the selected member's SSR Loox markup.
   * Does not touch the title rating (that lives in hot-swapped product content).
   */
  function renderReviewsMember(member) {
    var section = getSection();
    if (!section) return false;

    if (lastReviewsMember === member) return false;

    var template = qs(section, TEMPLATE_SEL + '[data-product-set-loox-template="' + member + '"]');
    var mount = qs(section, MOUNT_SEL);
    if (!mount || !template) {
      lastReviewsMember = member;
      section.setAttribute('data-product-set-loox-active-member', member);
      return false;
    }

    var clone = template.content.cloneNode(true);
    var widget = clone.querySelector('.loox-reviews-default') || clone.firstElementChild;
    if (!widget) return false;

    ensureSingleLooxReviewsId(widget);
    mount.innerHTML = '';
    mount.appendChild(widget);

    lastReviewsMember = member;
    section.setAttribute('data-product-set-loox-active-member', member);
    return true;
  }

  function onContentReplaced(event) {
    var member =
      (event.detail && event.detail.member) || getActiveMember();

    // Reviews: replace mount from member template (outside product content).
    renderReviewsMember(member);

    // Rating: already replaced by family-member content swap with the correct
    // member .loox-rating shell. Only ask Loox to paint the new empty host(s).
    callLooxEnhance();
  }

  function bind() {
    var root = getRoot();
    if (!root || root.getAttribute(BOUND) === 'true') return;
    root.setAttribute(BOUND, 'true');

    document.addEventListener('product-set:content-replaced', onContentReplaced);

    // Initial Dog (or only-member) rating + reviews are already correct from Liquid.
    // Do not remount or reload — that strips Loox's first paint of the title rating.
    lastReviewsMember = getActiveMember();

    var section = getSection();
    if (section) {
      section.setAttribute('data-product-set-loox-active-member', lastReviewsMember);
      var mount = qs(section, MOUNT_SEL);
      var host = mount && qs(mount, '#looxReviews, .loox-reviews-default');
      if (host) ensureSingleLooxReviewsId(host);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
